

const RGPDComponent = (_props: any) => {
  return (
    <div className="align-items-center justify-content-center">
      <h2 className="register-title text-center mb-0">Gestion de vos données et vos droits</h2>
    </div>
  );
};

export default RGPDComponent;
